const ASK_DOST_URL = "api/askai";
const BUSINESS_ANALYTICS_SERVICE_URL = "/api/businessanalyticsservice";
const CATALOG_SERVICE_URL = "api/catalogservice";
const CUSTOMER_SERVICE_URL = "api/customerService";
const DOCUMENT_SERVICE_URL = `/api/documentService`;
const DOCUMENT_SERVICE_URL_V2 = `api/documentService`;
const EMAIL_INPUT_CONNECTOR_SERVICE_URL = `api/emailInputConnector`;
const EXPENSE_SERVICE_URL = "/api/expenseservice";
const EXPORT_SERVICE_URL = "/api/exportTemplateService";
const EXTRACTION_SERVICE_URL = "/api/extractionservice";
const INVOICE_COMPLIANCE_SERVICE_URL = "api/invoicecomplianceservice";
const MANUAL_DOCUMENT_SERVICE_URL = "/api/manualDocumentService/ManualDocument";
const MAPPING_SERVICE_URL = "/api/mappingService/InputMappings";
const PAYMENT_SERVICE_URL = "/api/paymentService";
const PREDEFINED_VALUE_SERVICE = "api/predefinedvalueservice";
const PROCUREMENT_SERVICE_URL = "/api/procurementService";
const SUBSCRIPTION_SERVICE_URL = "/api/subscriptionService";
const USER_SERVICE_URL = "api/userService";
const VALIDATION_SERVICE_URL = "api/validationService";
const VENDOR_SERVICE_URL = "api/vendorService";
const WEBHOOK_SERVICE_URL = "/api/webhookService";
const WORKFLOW_SERVICE_URL = "/api/workflowService";

export {
  ASK_DOST_URL,
  BUSINESS_ANALYTICS_SERVICE_URL,
  CATALOG_SERVICE_URL,
  CUSTOMER_SERVICE_URL,
  DOCUMENT_SERVICE_URL,
  DOCUMENT_SERVICE_URL_V2,
  EMAIL_INPUT_CONNECTOR_SERVICE_URL,
  EXPENSE_SERVICE_URL,
  EXPORT_SERVICE_URL,
  EXTRACTION_SERVICE_URL,
  INVOICE_COMPLIANCE_SERVICE_URL,
  MANUAL_DOCUMENT_SERVICE_URL,
  MAPPING_SERVICE_URL,
  PAYMENT_SERVICE_URL,
  PREDEFINED_VALUE_SERVICE,
  PROCUREMENT_SERVICE_URL,
  SUBSCRIPTION_SERVICE_URL,
  USER_SERVICE_URL,
  VALIDATION_SERVICE_URL,
  VENDOR_SERVICE_URL,
  WEBHOOK_SERVICE_URL,
  WORKFLOW_SERVICE_URL
};

